import React, { useState, useRef } from 'react'
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { Input } from '../../../UI/InputElement/InputElement'
import SignatureCanvas from 'react-signature-canvas'
import { newAreaValidator as validate } from '../../../../../utility/validator/validator';

let LogBookFeedback = (props) => {
    const [isLoading, setIsloading] = useState(false);
    const [isNameEmpty, setIsNameEmpty] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const [isSignatureEmpty, setIsSignatureEmpty] = useState(false);
    let signatureShade = useRef({});

    let clearSign = () => {
        signatureShade.clear();
    };

    const onSubmitImage = () => {
        if (signatureShade.isEmpty() === false && props.logbookForm.LogBookFeedbackForm.values.logbook_log.name.length > 0 && props.logbookForm.LogBookFeedbackForm.values.logbook_log.is_agreed === true) {
            setIsloading(true);
            let logFeedbackValues = props.logbookForm.LogBookFeedbackForm.values;
            let sigImageFile = signatureShade.getTrimmedCanvas().toDataURL("image/png")
            let onSubmitLogValues = {logFeedbackValues, sigImageFile}
            setTimeout(() => {
                console.log(onSubmitLogValues);
                props.onSignatureAdded(onSubmitLogValues);
            }, 1000);
        }else if (signatureShade.isEmpty() === true || props.logbookForm.LogBookFeedbackForm.values.logbook_log.name.length === 0 || props.logbookForm.LogBookFeedbackForm.values.logbook_log.is_agreed === null) {            
            props.logbookForm.LogBookFeedbackForm.values.logbook_log.name.length === 0 ? setIsNameEmpty(true) : setIsNameEmpty(false);
            props.logbookForm.LogBookFeedbackForm.values.logbook_log.is_agreed === null || props.logbookForm.LogBookFeedbackForm.values.logbook_log.is_agreed === false ? setIsChecked(true) : setIsChecked(false);
            signatureShade.isEmpty() === true ? setIsSignatureEmpty(true) : setIsSignatureEmpty(false);
        }
    };
    
    return (
        <main class="app-content qr_app_content app_screen_outer schedule-screen ups_schedule">
        <div class="client_login list_view">
            <div class="login_form_content Schedule_con">
                <div className="comments_wrap">
                    <form className="form_content">
                        <div className="form-group">
                            <label htmlFor="name" className="form_title font-weight-bold">Please enter your name </label>
                            <Input name="logbook_log[name]" className="form-control textarea_modifier" placeholder="Your name" id="logbook_log[name]" />
                            {isNameEmpty === true ? <span style={{color: 'red', fontFamily: 'serif', fontWeight: 'bold', fontSize: '15px'}}>&nbsp;&nbsp;This field is required </span> : null}
                        </div>
                        <div className="checkbox_block radius_checkbox">
                            <div className="custom-control custom-checkbox custom-control-inline">
                                <Input type="checkbox" name='logbook_log[is_agreed]' className="custom-control-input" id='logbook_log[is_agreed]' />
                                <label className="custom-control-label" htmlFor={`logbook_log[is_agreed]`}><span style={{fontSize: '15px', fontWeight: '700'}}> I attest to the completion of this log in accordance with Good Documentation Practices. </span></label>
                            </div>
                            {isChecked === true ? <span style={{color: 'red', fontFamily: 'serif', fontWeight: 'bold', fontSize: '15px'}}>&nbsp;&nbsp;This field is required </span> : null}
                        </div>
                        <div className="form-group">
                            <label htmlFor="comment" className="form_title font-weight-bold">Please enter your comment</label>
                            <Input name="logbook_log[comment]" type="textarea" className="form-control textarea_modifier" rows="2" placeholder="Your comment" id="logbook_log[comment]" />
                        </div>
                        <div className="form-group">
                            <label className="form_title font-weight-bold">Please provide your initial</label>
                            <SignatureCanvas 
                                ref={(ref) => { signatureShade = ref; }} 
                                penColor='black' backgroundColor='white'
                                canvasProps={{width: 500, height: 150, className: 'form-control textarea_modifier'}}
                            />
                            {isSignatureEmpty === true ? <span style={{color: 'red', fontFamily: 'serif', fontWeight: 'bold', fontSize: '15px'}}>&nbsp;&nbsp;This field is required </span> : null}
                            <div style={{display: 'flex', justifyContent: 'flex-end'}}><button type="button" onClick={clearSign} className="btn mr-2 btn-outline-secondary">Clear</button></div>
                            
                        </div>
                        <div className="form-group btn_block mb-0">
                            <button style={{display: "inline-block"}} data-test="submit_button" onClick={onSubmitImage} type="button" className={isLoading ? "btn cst_btn btn_danger btn-wait btn_core mr-2 w-100 py-3" : "btn cst_btn btn_danger mr-2 w-100 py-3"} >{'Submit'}</button>
                            <button data-test="cancel_button" type="button" className="btn btn-outline-secondary w-100 py-3 mb-3 mt-3" onClick={() => {props.scanLogbookPage()}} >Cancel</button>
                        </div>
                        {/* {sigImageFile ? 
                        ( <img src={sigImageFile} alt="sign-image" style={{ width: "300px", height: "100px", border: "3px groove pink", display: "block", margin: "0 auto" }} /> ) 
                        : null} */}
                    </form>
                </div>
            </div>
        </div>
        </main>
    );
}

const mapStateToProps = (state, props) => {
    
    return {
      initialValues:
      {
        logbook_log:{
            name: '',
            comment: '',
            is_agreed: null,
            initial: '',
        }
      },
      logbookForm: state.form
    }
  };

LogBookFeedback = reduxForm({
  form: 'LogBookFeedbackForm',
  validate,
  enableReinitialize: true,
})(LogBookFeedback);

LogBookFeedback = connect(mapStateToProps)(LogBookFeedback);

export default LogBookFeedback